/**
 * Simple Shopify Minimum Quantity Fix
 * This script ensures the quick add buttons use minimum quantities
 * without relying on external resources or complex logic.
 */

// Wait for the page to fully load
document.addEventListener('DOMContentLoaded', function() {
  // Default minimum quantity for your products
  const DEFAULT_MIN_QTY = 12;
  
  // Simple function to find and fix all add to cart buttons
  function fixAddToCartButtons() {
    // Target all add to cart buttons
    const addToCartButtons = document.querySelectorAll('.add_to_cart_button, .add-to-cart, button.add_to_cart');
    
    // Process each button
    addToCartButtons.forEach(function(button) {
      // Skip if already processed
      if (button.hasAttribute('data-min-qty-fixed')) {
        return;
      }
      
      // Mark as processed
      button.setAttribute('data-min-qty-fixed', 'true');
      
      // Save original click handler
      const originalClickHandler = button.onclick;
      
      // Replace with our handler
      button.onclick = function(event) {
        event.preventDefault();
        
        // Get form or product container
        const form = button.closest('form');
        
        if (form) {
          // Handle form-based add to cart
          const quantityInput = form.querySelector('input[name="quantity"]');
          if (quantityInput) {
            // Set minimum quantity
            quantityInput.value = DEFAULT_MIN_QTY;
          }
          
          // Submit the form
          form.submit();
        } else {
          // Direct add to cart (Ajax)
          const productId = button.getAttribute('data-product-id') || 
                           button.getAttribute('data-variant-id');
          
          if (productId) {
            // Add directly to cart with minimum quantity
            addToCart(productId, DEFAULT_MIN_QTY);
          }
        }
        
        return false;
      };
    });
  }
  
  // Simple function to add product to cart
  function addToCart(variantId, quantity) {
    // Create data
    const data = {
      id: variantId,
      quantity: quantity
    };
    
    // Use Shopify Ajax API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      // Show success message
      alert('Added to cart with minimum quantity: ' + quantity);
      
      // Reload page to reflect cart changes
      window.location.reload();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      alert('Could not add to cart. Please try again.');
    });
  }
  
  // Run immediately
  fixAddToCartButtons();
  
  // Also run periodically to catch dynamically added buttons
  setInterval(fixAddToCartButtons, 2000);
});